import GridCollection from "./grid-collection.component.vue";

export default GridCollection;
